<template>
  <v-dialog
    v-model="dialog"
    :width="
      accountSettings && accountSettings.storage_flg == 1 ? '960px' : '800px'
    "
    persistent
  >
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col
          cols="12"
          :sm="
            accountSettings &&
            accountSettings.storage_flg == 1 &&
            !showCategories
              ? 4
              : 6
          "
        >
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="materialKeyword"
              :label="$t('Material.materialNameKeyword')"
            />
          </v-row>
        </v-col>
        <v-col
          cols="12"
          :sm="
            accountSettings &&
            accountSettings.storage_flg == 1 &&
            !showCategories
              ? 4
              : 6
          "
        >
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategory v-model="categorySelected" />
          </v-row>
        </v-col>
        <v-col
          cols="12"
          :sm="!showCategories ? 4 : 6"
          v-if="accountSettings && accountSettings.storage_flg == 1"
        >
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="storageKeyword"
              v-model="storageKeyword"
              :label="$t('Material.Fields.storage_conditions')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" :sm="!showCategories ? 4 : 6" v-if="showCategories">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialShowCategoriesWithDescendants v-model="showCategoriesSelected" />
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="materialItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.valid>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              materials.find((detail) => detail.valid != validAll)
                ? true
                : false
            "
            v-model="validAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("TakeTemplates.DetailFields.valid_all") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.Description="{ item }">
          <span
            v-if="item.standard_name && item.standard_name.length > 12"
            :title="item.standard_name"
            style="cursor: pointer"
          >
            {{ item.Description }}
          </span>
          <span v-else>
            {{ item.Description }}
          </span>
        </template>
        <template v-slot:item.valid="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.valid"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.valid ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
        <template v-slot:item.show_categories="{ item }">
          <v-tooltip
            right
            v-if="item.show_categories && item.show_categories.length > 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{
                  item.show_categories[0].parent_show_category
                    ? item.show_categories[0].parent_show_category.name + " : "
                    : ""
                }}
                {{ item.show_categories[0].name }}
                {{ item.show_categories.length > 1 ? "..." : "" }}
              </span>
            </template>
            <span
              v-for="(show_category, index) in item.show_categories"
              :key="show_category.id"
              class="d-inline"
            >
              {{
                show_category.parent_show_category
                  ? show_category.parent_show_category.name + " : "
                  : ""
              }}
              {{
                show_category.name +
                (index == item.show_categories.length - 1 ? "" : ",")
              }}
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirmWithChooseCount", [choosedLength]) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockMaterials from "@/api/stock_materials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterialShowCategoriesWithDescendants from "@/components/plugins/SearcherMaterialShowCategoriesWithDescendants";
export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    showCategories: Boolean,
    templateDetails:Array
  },

  components: {
    SearcherKeyword,
    SearcherMaterialCategory,
    SearcherMaterialShowCategoriesWithDescendants,
  },

  computed: {
    headers() {
      let headers = [
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
      ];
      if (this.showCategories) { 
         headers.push( {
          text: i18n.t("Material.Fields.show_categories"),
          align: "start",
          sortable: false,
          value: "show_categories",
        },);
      }
      if (this.accountSettings && this.accountSettings.storage_flg == 1) {
        headers.push({
          text: i18n.t("Material.Fields.storage_conditions"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "storage_conditions",
        });
      }
      headers.push(
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("TakeTemplates.DetailFields.valid_all"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "valid",
        }
      );
      return headers;
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    materialItems() {
      //前端搜索
      return this.materials.filter(
        (item) =>
          ((this.categorySelected &&
            item.category_code.indexOf(this.categorySelected.code) > -1) ||
            !this.categorySelected) &&
          ((this.materialKeyword &&
            item.Description.indexOf(this.materialKeyword) > -1) ||
            !this.materialKeyword) &&
          ((this.storageKeyword &&
            item.storage_conditions &&
            item.storage_conditions.indexOf(this.storageKeyword) > -1) ||
            !this.storageKeyword) &&
          ((this.showCategoriesSelected.length &&
            item.show_categories.some(
              (d) =>
                this.showCategoriesSelected.findIndex(
                  (c) =>
                    c.show_material_category_id == d.show_material_category_id
                ) > -1
            )) ||
            !this.showCategoriesSelected.length)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountSettings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    materialKeyword: "",
    storageKeyword: "",
    categorySelected: null,
    itemsPerPageOptions: 10,
    choosedLength: 0,
    showCategoriesSelected: [],
    validAll: 0,
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    //获取material列表
    getMaterialsFromAPI() {
      this.materialsLoading = true;
      StockMaterials.fetchAll({}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.stock_materials.map((material) => {
              delete material.id
              material.Description = i18n.t(
                "Material.materialNameWithCodeAndStandard",
                [
                  material.material_code,
                  material.material_name,
                  material.standard_name && material.standard_name.length > 12
                    ? material.standard_name.slice(0, 12) + "......"
                    : material.standard_name,
                ]
              );
              var item = this.templateDetails.find((detail) => detail.material_id == material.material_id)
                if (item) {
                  material.valid = item.valid
                  material.status = item.status
                } else { 
                  material.valid = 0
                  material.status = 0
                }
              return material;
            });
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.materials.filter(
        function (e) {
          return e.valid || e.valid != e.status
        } 
      )
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
            this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.materialKeyword = "";
          this.categorySelected = null;
          this.validAll = 0;
          this.materials = [];
          this.showCategoriesSelected = [];
        }
        this.$emit("input", this.dialog);
      },
    },
    validAll: {
      handler() {
        this.materials = this.materials.map(
          function (e) {
            var item = this.materialItems.find(
              (m) => m.material_id == e.material_id
            );
            if (item) e.valid = this.validAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    materials: {
      deep: true,
      handler() {
        this.choosedLength = 0
        this.materials.forEach((material) => {
          if (material.valid)
          {
            this.choosedLength = this.choosedLength + 1;
          }
        });
      },
    },
  },
};
</script>